import React, {Proptype, Component} from 'react'
import {browserHistory} from 'react-router'
import DefaultTab from './DefaultTab'
import {connect} from 'react-redux'
import './Poster.scss'
import { alert } from 'util/alert';
import { confirm } from 'util/confirm';
import Restricted from 'containers/Restricted'
import PosterTypeModal from 'template/Modals/PosterType'
import __R from 'containers/__R';

import {
  Button,
	PanelWrapper,
	Tab,
	Tabs,
	TabList,
	TabPanel,
} from 'components/UI'

const mapStateToProps = (state) => ({
})

class Poster extends Component {
  constructor(props){
    super(props)

  }

  render(){
    return(
      <PanelWrapper>
        <div>
          {__("Posters", "header.sidemenu")}
        </div>
        <Tabs>
          <TabList>
            <Tab>{__('All', 'poster')}</Tab>
            <Tab>{__('Published', 'poster')}</Tab>
            <Tab>{__('Draft', 'poster')}</Tab>
            <Tab>{__('Closed', 'poster')}</Tab>
            <__R can="create_poster" by="disable">
              <Button bsStyle='primary' className="pull-right" onClick={()=>{
                PosterTypeModal()
              }}>
              {__("New Poster", "poster")}
              </Button>
            </__R>
            <Button bsStyle='primary' className="pull-right" onClick={()=>{
                browserHistory.push(`/registration-table/`);
              }}>
              {__("Registration List", "registrationTable")}
              </Button>
          </TabList>

          <TabPanel>
            <DefaultTab posterState={'all'} />
          </TabPanel>
          <TabPanel>
            <DefaultTab posterState={'published'} />
          </TabPanel>
          <TabPanel>
            <DefaultTab posterState={'draft'} />
          </TabPanel>
          <TabPanel>
            <DefaultTab posterState={'closed'} />
          </TabPanel>
        </Tabs>
      </PanelWrapper>
    )
  }
}

export default connect(mapStateToProps)(Poster)



// WEBPACK FOOTER //
// ./src/containers/pages/Poster/index.js